import { useMemo } from "react"
import buttonContent from "../config/button-icon"
import actionContent from "../config/button-action"
import { ActionButtonContent, IconButtonContent } from "../types/button-content"
import { TenantButtonCopy } from "@hydrologiq/gql/graphql"
export type IconButtonTypes = keyof typeof buttonContent
export type ButtonContent = ActionButtonContent

export const useIconButtonContent = (key?: IconButtonTypes, copy?: TenantButtonCopy): IconButtonContent | undefined => {
  return useMemo(() => {
    if (!key) return undefined
    const button = copy
    const icon = buttonContent[key as keyof typeof buttonContent]

    if (button) return { ...icon, ...(button as unknown as IconButtonContent) }

    if (icon) return { ...icon }
  }, [key])
}

export type ActionButtonTypes = keyof typeof actionContent

export const useActionButtonContent = (
  key?: ActionButtonTypes,
  copy?: TenantButtonCopy
): ActionButtonContent | undefined => {
  return useMemo(() => {
    if (!key) return undefined
    const button = copy
    const action = actionContent[key as keyof typeof actionContent]

    if (button) return { ...action, ...(button as ActionButtonContent) }

    if (action) return { ...action }

    return undefined
  }, [key])
}
